export default __webpack_public_path__ + "static/media/18.661222e1.mp3";